import {DraftErrorsFactory} from '../Errors/factory.js'
import {DraftValueObjectsFactory} from '../ValueObjects/factory.js'
import {FromDraftParamToRequestDraftValueObjectMapper} from './FromDraftParamToRequestDraftValueObjectMapper.js'
import {FromPublishDraftResponseToUrlValueObjectMapper} from './FromPublishDraftResponseToUrlValueObjectMapper.js'

export class DraftMappersFactory {
  static fromPublishDraftResponseToUrlValueObjectMapper = ({config}) =>
    new FromPublishDraftResponseToUrlValueObjectMapper({
      publishDraftErrorFactory: DraftErrorsFactory.publishDraftError,
      urlPublishDraftValueObject: DraftValueObjectsFactory.urlPublishDraftValueObject,
      config
    })

  static fromDraftParamToRequestDraftValueObjectMapper = ({config}) =>
    new FromDraftParamToRequestDraftValueObjectMapper({
      requestDraftValueObject: DraftValueObjectsFactory.requestDraftValueObject,
      config
    })
}
